module.exports = __webpack_public_path__ + "img/nursery8.ecc742ec.jpg";